import { cva, type VariantProps } from 'class-variance-authority';

export const meterFillVariants = cva('block h-full origin-left rounded-meter', {
  variants: {
    tone: { accent: 'bg-accent-mark', danger: 'bg-danger', info: 'bg-info' },
  },
  defaultVariants: { tone: 'accent' },
});

export type MeterTone = NonNullable<VariantProps<typeof meterFillVariants>['tone']>;
